import { Component, OnInit } from '@angular/core';
import { EnvironmentService } from '../../../services/environment.service';
import { AuthenticationService } from 'src/app/core/services/authentication.service';

@Component({
  selector: 'app-about-us',
  templateUrl: './about-us.component.html',
  styleUrls: ['./about-us.component.scss'],
})
export class AboutUsComponent implements OnInit {

  toShowLabel = this.env.envVariables.companyName;
  currentYear: number = new Date().getFullYear();
  syncHpcVersion: string = this.authenticationService.SyncHPCVersion.replace("Version ", "V");

  constructor(
    private env: EnvironmentService,
    private authenticationService: AuthenticationService
  ) { }

  ngOnInit() {}

  downloadFile() {
    const link = document.createElement('a');
    link.setAttribute(
      'href',
      this.env.envVariables.syncAutoDownloadLink
    );
    document.body.appendChild(link);
    link.click();
    link.remove();
  }

  downloadSyncVdiClient() {
    const link = document.createElement('a');
    link.setAttribute(
      'href',
      this.env.envVariables.syncVdiClientDownloadLink
    );
    document.body.appendChild(link);
    link.click();
    link.remove();
  }

  downloadSyncVdiServiceWin() {
    const link = document.createElement('a');
    link.setAttribute(
      'href',
      this.env.envVariables.syncVdiServiceWinDownloadLink
    );
    document.body.appendChild(link);
    link.click();
    link.remove();
  }

  downloadSyncVdiServiceLin() {
    const link = document.createElement('a');
    link.setAttribute(
      'href',
      this.env.envVariables.syncVdiServiceLinDownloadLink
    );
    document.body.appendChild(link);
    link.click();
    link.remove();
  }

  downloadSyncVdiGateway() {
    const link = document.createElement('a');
    link.setAttribute(
      'href',
      this.env.envVariables.syncVdiGatewayLink
    );
    document.body.appendChild(link);
    link.click();
    link.remove();
  }
}
